enum ExportBiRunStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  PARTIAL = "PARTIAL",
  FAILED = "FAILED",
}

type ExportBiRunResult = {
  documents: { [dataset: string]: string };
  errors: string[];
};

type ExportBiRun = {
  runId: string;
  planzoneId: string;
  startDate: string;
  endDate: string;
  status: ExportBiRunStatus;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
  result: ExportBiRunResult | null;
};

const exportBiRun: ExportBiRun = {
  runId: "",
  planzoneId: "",
  startDate: "",
  endDate: "",
  status: ExportBiRunStatus.PENDING,
  createdAt: "",
  startedAt: null,
  completedAt: null,
  result: null,
};

export type { ExportBiRun, ExportBiRunResult };

export { ExportBiRunStatus, exportBiRun };
